/*========================== Add bag with variants*/

var currentModal = null; // Variable para almacenar el modal actual
var currentAddToBagBtn = null; // Variable para almacenar el botón "Add to Bag" actual

// Evento que se ejecuta cuando el DOM está completamente cargado
document.addEventListener('DOMContentLoaded', function () {

	var heightNavigationCarrousel = document.querySelector('.naviagtion__carousel').offsetHeight
	var heightNavigationNavigation = document.querySelector('.navigation__home').offsetHeight
	var heightNavigationAll = heightNavigationCarrousel + heightNavigationNavigation


	var productForms = document.querySelectorAll('.add-to-cart-form'); // Selecciona todos los formularios de "add to cart"

	// Itera sobre cada formulario de producto
	productForms.forEach(function (form) {
		var variantRadios = form.querySelectorAll('.variant-radio'); // Selecciona todos los radios de variantes dentro del formulario
		var addToCartBtn = form.querySelector('.add-to-cart-btn'); // Selecciona el botón "add to cart" dentro del formulario
		var contentVariants = form.closest('.content_variants'); // Selecciona el contenedor más cercano con la clase "content_variants"

		// Variables para contenedores específicos en Safari
		if (document.querySelector('.safari__container')) {
			var containerModalSafari = document.querySelector('.safari__container');
		}
		if (document.querySelector('.safari__container--nowrap')) {
			var containeWrapSafari = document.querySelector('.safari__container--nowrap');
		}


		// Evento que se ejecuta cuando se hace clic en el botón "add to cart"
		addToCartBtn.addEventListener('click', function (event) {


			if (window.innerWidth > 768) {
				// Selecciona todos los elementos con la clase 'container-fluid'
				const containers__slider = document.querySelectorAll('.container-fluid');

				// Recorre cada uno de los elementos y agrega la clase 'overflow-auto'
				containers__slider.forEach(container__slider => {
					container__slider.classList.add('overflow-auto');
				});
			}


			if (window.innerWidth <= 768) { // Puedes ajustar este valor según sea necesario para definir "móvil"
				// Encuentra el elemento con ambas clases
				var contentVariantsElements = document.querySelectorAll('.content_variants');
				// Itera sobre cada elemento
				contentVariantsElements.forEach(function (contentVariantsElement) {
					// Encuentra todos los elementos con la clase add-to-cart-btn dentro del elemento actual
					var addToCartButtons = contentVariantsElement.querySelectorAll('.add-to-cart-btn');
					// Itera sobre cada botón y cambia la propiedad bottom
					addToCartButtons.forEach(function (addToCartButton) {
						addToCartButton.style.setProperty('bottom', '0px', 'important');
					});
				});
			}

			document.querySelectorAll('.fixed-bottom').forEach(element => element.style.zIndex = 4);


			document.querySelectorAll('.pdp__container').forEach(element => element.style.zIndex = 0);

			var elementContainer = document.querySelector('.content'); // Selecciona el contenedor con la clase "content"

			// Aplica display: block al contenedor si la ventana es menor a 768px
			if (window.innerWidth < 768) {
				if (elementContainer) {
					elementContainer.style.display = 'block';
				}
			}

			if (window.innerWidth < 768) {
				var heightNavigationCarrousel = document.querySelector('.naviagtion__carousel').offsetHeight
				var heightNavigationNavigation = document.querySelector('.navigation__home').offsetHeight
				var heightNavigationAll = heightNavigationCarrousel + heightNavigationNavigation

				document.querySelector('.background__nav').classList.add('active');
				document.querySelector('.background__nav').style.height = heightNavigationAll + 'px'
			}
			// Ajusta el z-index de la navegación según el tamaño de la ventana
			if (window.innerWidth > 768) {
				document.querySelector('nav').style.zIndex = '9';
			} else {
				document.querySelector('nav').style.zIndex = '10';
			}

			// Muestra el contenido de fondo que coincide con el ID del formulario
			document.querySelectorAll('.background__content').forEach(element => {
				if (element.id === form.id) {
					element.classList.remove('hidden');
				}
			});

			var selectedRadio = form.querySelector('input[name="id"]:checked'); // Selecciona el radio seleccionado
			if (containerModalSafari) {
				containerModalSafari.classList.remove('overflow-auto');
				containerModalSafari.style.overflow = '-webkit-paged-y';
			}
			if (containeWrapSafari) {
				containeWrapSafari.classList.remove('flex-nowrap');
			}

			// Ajusta el z-index de los elementos con la clase "collection-z-index" según el tamaño de la ventana
			if (document.querySelectorAll('.collection-z-index')) {
				const elements = document.querySelectorAll('.collection-z-index');
				elements.forEach(element => {
					element.addEventListener('click', () => {
						elements.forEach(el => el.style.setProperty('z-index', 'auto', 'important'));
						if (window.innerWidth > 768) {
							element.style.setProperty('z-index', '7', 'important');
						} else {
							element.style.setProperty('z-index', '8', 'important');
						}
					});
				});
			}

			// Muestra los contenedores de variantes si la ventana es menor a 768px
			if (window.innerWidth < 768) {
				var variantContainers = document.querySelectorAll('.content_items--variant');
				variantContainers.forEach(function (variantContainer) {
					variantContainer.style.setProperty('display', 'flex', 'important');
				});
			}

			// Si no hay radio seleccionado, muestra las variantes
			if (!selectedRadio) {
				contentVariants.classList.add('show-variant-selected');
				document.body.classList.add('body-variant-selected');
				event.preventDefault();

				if (contentVariants && contentVariants.firstElementChild) {
					contentVariants.firstElementChild.style.display = 'block';
				}
			} else {
				var price = selectedRadio.getAttribute('data-price');
				var variantId = selectedRadio.value;
				addToCartBtn.textContent = 'Add to Bag ' + price;
				addToCartBtn.setAttribute('data-variant-id', variantId);
				addToCartBtn.classList.add('add-to-cart-upsell');
				addToCartBtn.classList.add('variant-selected');
			}

			// Restablece el modal y el botón "Add to Bag" anteriores
			if (currentModal && currentModal !== contentVariants) {
				currentModal.classList.remove('show-variant-selected');
				currentAddToBagBtn.textContent = 'Add to Bag';
				resetVariantRadios(currentModal);
				currentAddToBagBtn.classList.remove('variant-selected');
				currentAddToBagBtn.classList.remove('add-to-cart-upsell');
			}

			currentModal = contentVariants; // Actualiza el modal actual
			currentAddToBagBtn = addToCartBtn; // Actualiza el botón "Add to Bag" actual
		});

		// Evento que se ejecuta cuando se selecciona una variante
		variantRadios.forEach(function (radio) {
			radio.addEventListener('change', function () {

				var selectedRadio = form.querySelector('input[name="id"]:checked');
				var price = selectedRadio.getAttribute('data-price');
				var variantId = selectedRadio.value; // Captura el ID de la variante seleccionada
				addToCartBtn.textContent = 'Add to Bag ' + price;
				addToCartBtn.setAttribute('data-variant-id', variantId); // Asigna el ID de la variante al botón
				addToCartBtn.classList.add('add-to-cart-upsell');
				contentVariants.classList.remove('no-variant-selected');
				addToCartBtn.classList.add('variant-selected');
			});
		});

		if (window.innerWidth < 768) {
			// Selecciona todos los elementos con la clase 'product__mobile--container'
			const containers = document.querySelectorAll('.product__mobile--container');
			// Selecciona todos los elementos con la clase 'product__mobile--id'
			const ids = document.querySelectorAll('.product__mobile--id');

			// Crea un conjunto de IDs para una búsqueda rápida
			const idsSet = new Set();
			ids.forEach(item => {
				idsSet.add(item.id);
			});

			// Itera sobre cada uno de los elementos seleccionados
			containers.forEach(container => {
				// Verifica si el ID del contenedor no está en el conjunto de IDs
				if (!idsSet.has(container.id)) {
					// Establece el z-index en 0 con !important
					container.style.setProperty('z-index', '0', 'important');
				}
			});
		}
	});
});

// Función para cerrar el modal
function closeModal(productId) {

	// debugger
	var contentVariants = document.querySelector('#content_variants_' + productId);
	if (contentVariants) {
		contentVariants.classList.remove('show-variant-selected');
	}
	document.body.classList.remove('body-variant-selected');

	// Restablece el z-index de los elementos con la clase "collection-z-index"
	if (document.querySelectorAll('.collection-z-index')) {
		const elements = document.querySelectorAll('.collection-z-index');
		elements.forEach(element => {
			element.addEventListener('click', () => {
				elements.forEach(el => el.style.setProperty('z-index', '2', 'important'));
				element.style.setProperty('z-index', '3', 'important');
			});
		});
	}


	if (window.innerWidth <= 768) { // Puedes ajustar este valor según sea necesario para definir "móvil"
		// Encuentra el elemento con ambas clases
		var contentVariantsElements = document.querySelectorAll('.content_variants');
		// Itera sobre cada elemento
		contentVariantsElements.forEach(function (contentVariantsElement) {

			// Encuentra todos los elementos con la clase add-to-cart-btn dentro del elemento actual
			var addToCartButtons = contentVariantsElement.querySelectorAll('.add-to-cart-btn');
			// Itera sobre cada botón y cambia la propiedad bottom
			addToCartButtons.forEach(function (addToCartButton) {
				addToCartButton.style.setProperty('bottom', '-185px');
			});
		});
	}


	// Oculta los contenedores de variantes si la ventana es menor a 768px
	if (window.innerWidth < 768) {
		var variantContainers = document.querySelectorAll('.content_items--variant');
		variantContainers.forEach(function (variantContainer) {
			variantContainer.style.display = "none";
		});
	}

	// Variables para contenedores específicos en Safari
	if (document.querySelector('.safari__container')) {
		var containerModalSafari = document.querySelector('.safari__container');
	}
	if (document.querySelector('.safari__container--nowrap')) {
		document.querySelector('.safari__container--nowrap').classList.toggle('flex-nowrap');
	}

	// Oculta el contenido de fondo que coincide con el ID del producto
	document.querySelectorAll('.background__content').forEach(element => {
		if (element.id === productId) {
			element.classList.add('hidden');
		}
	});

	// Agrega la clase 'active' a '.background__nav'
	if (window.innerWidth < 768) {
		document.querySelector('.background__nav').classList.remove('active');
		document.querySelector('.background__nav').style.height = '0px'
	}


	if (containerModalSafari) {
		containerModalSafari.classList.add('overflow-auto');
	}


	if (contentVariants.querySelector('.add-to-cart-btn')) {
		var addToCartBtn = contentVariants.querySelector('.add-to-cart-btn');

	}
	var addToCartBtnOutside = contentVariants.querySelector('.add-to-cart-btn-outside');
	addToCartBtn.textContent = 'Add to Bag';
	addToCartBtn.classList.remove('variant-selected');
	addToCartBtn.classList.remove('add-to-cart-upsell');

	// Evento que se ejecuta cuando se hace clic en el botón "Add to Bag"
	addToCartBtn.addEventListener('click', function (event) {
		if (!contentVariants.classList.contains('show-variant-selected')) {
			event.preventDefault();
			contentVariants.classList.add('show-variant-selected');
		}
	});

	if (currentModal === contentVariants) {
		currentModal = null;
		currentAddToBagBtn = null;
	}

	resetVariantRadios(contentVariants); // Restablece los radios de variantes
}

// Función para restablecer los radios de variantes
function resetVariantRadios(modal) {
	var variantRadios = modal.querySelectorAll('.variant-radio');
	variantRadios.forEach(function (radio) {
		radio.checked = false;
	});
}

/*========================= Show variants with Select stone (The Garden pendant)*/

document.addEventListener("DOMContentLoaded", function () {
	const productContainers = document.querySelectorAll('.content_variants'); // Selecciona todos los contenedores de variantes

	productContainers.forEach(function (container) {
		const stoneOptions = container.querySelectorAll('.stone-options li'); // Selecciona todas las opciones de piedra

		stoneOptions.forEach(function (option) {
			option.addEventListener('click', function () {
				const target = this.getAttribute('data-target');
				const targetName = this.getAttribute('data-name');

				stoneOptions.forEach(function (li) {
					li.classList.remove('active');
				});

				const forms = container.querySelectorAll('.stone-form');
				forms.forEach(function (form) {
					form.classList.remove('active');
				});

				this.classList.add('active');

				const formToShow = container.querySelector('#' + target);
				formToShow.classList.add('active');

				const variantStones = formToShow.querySelectorAll('.variant_stone');

				// Función para actualizar el precio
				function updatePrice() {
					const selectedRadio = formToShow.querySelector('.variant_stone:checked');
					const addToBagBtn = formToShow.querySelector('.btn_garden-pendant');
					if (selectedRadio) {
						const price = selectedRadio.getAttribute('data-price');
						const valueid = selectedRadio.getAttribute('value');
						addToBagBtn.textContent = 'Add to Bag ' + price;
						addToBagBtn.setAttribute('data-variant-id', valueid);
						addToBagBtn.classList.add('add-to-cart-upsell');
						addToBagBtn.classList.add('price-updated');
						addToBagBtn.classList.remove('price-added');
					} else {
						addToBagBtn.textContent = 'Add to Bag';
						addToBagBtn.classList.remove('price-updated');
						addToBagBtn.classList.remove('price-added');
						addToBagBtn.classList.remove('add-to-cart-upsell');
					}
				}

				variantStones.forEach(function (stone) {
					stone.addEventListener('change', updatePrice);
				});

				updatePrice();
			});

			if (option.classList.contains('active')) {
				option.click();
			}
		});





		// Evento que se ejecuta cuando se hace clic en el botón "Add to Bag"
		container.querySelectorAll('.btn_garden-pendant').forEach(function (btn) {
			btn.addEventListener('click', function (event) {


				if (window.innerWidth > 768) {
					// Selecciona todos los elementos con la clase 'container-fluid'
					const containers__slider = document.querySelectorAll('.container-fluid');

					// Recorre cada uno de los elementos y agrega la clase 'overflow-auto'
					containers__slider.forEach(container__slider => {
						container__slider.classList.add('overflow-auto');
					});
				}

				const priceUpdated = this.classList.contains('price-updated');
				if (!priceUpdated) {
					event.preventDefault();
					const contentStone = this.closest('.content_stone');
					contentStone.classList.add('bag-opened');

					document.querySelectorAll('.fixed-bottom').forEach(element => element.style.zIndex = 4);

					if (document.querySelector('.z-0')) {
						document.querySelector('.z-0').classList.add('changed');
						document.querySelector('.background__content').classList.remove('hidden');
					}

					const elements__pdp = document.querySelectorAll('.products-pdp .select_stone-items .content_stone .btn_garden-pendant');

					// Aplica el estilo z-index 0 a cada elemento seleccionado
					elements__pdp.forEach(function (element__pdp) {
						element__pdp.style.setProperty('bottom', '0', 'important');
						document.querySelector('.background__content').classList.remove('hidden');
					});

					if (window.innerWidth < 768) {
						var heightNavigationCarrousel = document.querySelector('.naviagtion__carousel').offsetHeight
						var heightNavigationNavigation = document.querySelector('.navigation__home').offsetHeight
						var heightNavigationAll = heightNavigationCarrousel + heightNavigationNavigation
						document.querySelector('.background__nav').classList.add('active');
						document.querySelector('.background__nav').style.height = heightNavigationAll + 'px'
					}
					if (window.innerWidth > 768) {
						document.querySelector('nav').style.zIndex = '9';
					} else {
						document.querySelector('nav').style.zIndex = '10';
					}
					document.body.classList.add('body-stone-selected');

				}
			});
		});

		// Evento que se ejecuta cuando se hace clic en el botón "close_stone"
		container.querySelectorAll('.close_stone').forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				event.preventDefault();
				const contentStone = this.closest('.content_stone');
				contentStone.classList.remove('bag-opened');
				if (document.querySelector('.z-0')) {
					document.querySelector('.z-0').classList.remove('changed');
				}


				const elements = document.querySelectorAll('.products-pdp .select_stone-items .content_stone .btn_garden-pendant');

				// Aplica el estilo z-index 0 a cada elemento seleccionado
				elements.forEach(function (element) {
					element.style.setProperty('bottom', '-185px', 'important');
					document.querySelector('.background__content').classList.remove('hidden');
				});


				document.querySelector('.background__content').classList.add('hidden');
				document.body.classList.remove('body-stone-selected');

				if (window.innerWidth < 768) {
					document.querySelector('.background__nav').classList.remove('active');
					document.querySelector('.background__nav').style.height = '0px'
				}
				const activeForm = container.querySelector('.stone-form.active');

				if (activeForm) {
					const addToBagBtn = activeForm.querySelector('.btn_garden-pendant');
					addToBagBtn.classList.remove('price-updated');
					addToBagBtn.classList.remove('add-to-cart-upsell');
					addToBagBtn.textContent = 'Add to Bag';
					event.preventDefault();
				}
			});
		});
	});
});


/*========================== Add bag with variants*/

var currentModal = null; // Variable para almacenar el modal actual
var currentAddToBagBtn = null; // Variable para almacenar el botón "Add to Bag" actual

// Evento que se ejecuta cuando el DOM está completamente cargado
document.addEventListener('DOMContentLoaded', function () {
	var heightNavigationCarrousel = document.querySelector('.naviagtion__carousel').offsetHeight
	var heightNavigationNavigation = document.querySelector('.navigation__home').offsetHeight
	var heightNavigationAll = heightNavigationCarrousel + heightNavigationNavigation


	var productForms = document.querySelectorAll('.add-to-cart-form'); // Selecciona todos los formularios de "add to cart"

	// Itera sobre cada formulario de producto
	productForms.forEach(function (form) {
		var variantRadios = form.querySelectorAll('.variant-radio'); // Selecciona todos los radios de variantes dentro del formulario
		var addToCartBtn = form.querySelector('.add-to-cart-btn'); // Selecciona el botón "add to cart" dentro del formulario
		var contentVariants = form.closest('.content_variants'); // Selecciona el contenedor más cercano con la clase "content_variants"

		// Variables para contenedores específicos en Safari
		if (document.querySelector('.safari__container')) {
			var containerModalSafari = document.querySelector('.safari__container');
		}
		if (document.querySelector('.safari__container--nowrap')) {
			var containeWrapSafari = document.querySelector('.safari__container--nowrap');
		}


		// Evento que se ejecuta cuando se hace clic en el botón "add to cart"
		addToCartBtn.addEventListener('click', function (event) {


			if (window.innerWidth <= 768) { // Puedes ajustar este valor según sea necesario para definir "móvil"
				// Encuentra el elemento con ambas clases
				var contentVariantsElements = document.querySelectorAll('.content_variants');
				// Itera sobre cada elemento
				contentVariantsElements.forEach(function (contentVariantsElement) {
					// Encuentra todos los elementos con la clase add-to-cart-btn dentro del elemento actual
					var addToCartButtons = contentVariantsElement.querySelectorAll('.add-to-cart-btn');
					// Itera sobre cada botón y cambia la propiedad bottom
					addToCartButtons.forEach(function (addToCartButton) {
						addToCartButton.style.setProperty('bottom', '0px', 'important');
					});
				});
			}

			// Selecciona todos los elementos con la clase 'hide-scrollbar'
			const elements__scroll = document.querySelectorAll('.hide-scrollbar');

			// Recorre cada elemento y elimina la clase 'overflow-auto' si está presente
			elements__scroll.forEach(element => {
				if (element.classList.contains('overflow-auto')) {
					element.classList.remove('overflow-auto');
				}
			});


			document.querySelectorAll('.fixed-bottom').forEach(element => element.style.zIndex = 4);


			document.querySelectorAll('.pdp__container').forEach(element => element.style.zIndex = 0);

			var elementContainer = document.querySelector('.content'); // Selecciona el contenedor con la clase "content"

			// Aplica display: block al contenedor si la ventana es menor a 768px
			if (window.innerWidth < 768) {
				if (elementContainer) {
					elementContainer.style.display = 'block';
				}
			}

			if (window.innerWidth < 768) {
				var heightNavigationCarrousel = document.querySelector('.naviagtion__carousel').offsetHeight
				var heightNavigationNavigation = document.querySelector('.navigation__home').offsetHeight
				var heightNavigationAll = heightNavigationCarrousel + heightNavigationNavigation

				document.querySelector('.background__nav').classList.add('active');
				document.querySelector('.background__nav').style.height = heightNavigationAll + 'px'
			}
			// Ajusta el z-index de la navegación según el tamaño de la ventana
			if (window.innerWidth > 768) {
				document.querySelector('nav').style.zIndex = '9';
			} else {
				document.querySelector('nav').style.zIndex = '10';
			}

			// Muestra el contenido de fondo que coincide con el ID del formulario
			document.querySelectorAll('.background__content').forEach(element => {
				if (element.id === form.id) {
					element.classList.remove('hidden');
				}
			});

			var selectedRadio = form.querySelector('input[name="id"]:checked'); // Selecciona el radio seleccionado
			if (containerModalSafari) {
				containerModalSafari.classList.remove('overflow-auto');
				containerModalSafari.style.overflow = '-webkit-paged-y';
			}
			if (containeWrapSafari) {
				containeWrapSafari.classList.remove('flex-nowrap');
			}

			// Ajusta el z-index de los elementos con la clase "collection-z-index" según el tamaño de la ventana
			if (document.querySelectorAll('.collection-z-index')) {
				const elements = document.querySelectorAll('.collection-z-index');
				elements.forEach(element => {
					element.addEventListener('click', () => {
						elements.forEach(el => el.style.setProperty('z-index', 'auto', 'important'));
						if (window.innerWidth > 768) {
							element.style.setProperty('z-index', '7', 'important');
						} else {
							element.style.setProperty('z-index', '8', 'important');
						}
					});
				});
			}

			// Muestra los contenedores de variantes si la ventana es menor a 768px
			if (window.innerWidth < 768) {
				var variantContainers = document.querySelectorAll('.content_items--variant');
				variantContainers.forEach(function (variantContainer) {
					variantContainer.style.setProperty('display', 'flex', 'important');
				});
			}

			// Si no hay radio seleccionado, muestra las variantes
			if (!selectedRadio) {
				contentVariants.classList.add('show-variant-selected');
				document.body.classList.add('body-variant-selected');
				event.preventDefault();

				if (contentVariants && contentVariants.firstElementChild) {
					contentVariants.firstElementChild.style.display = 'block';
				}
			} else {
				var price = selectedRadio.getAttribute('data-price');
				var variantId = selectedRadio.value;
				addToCartBtn.textContent = 'Add to Bag ' + price;
				addToCartBtn.setAttribute('data-variant-id', variantId);
				addToCartBtn.classList.add('add-to-cart-upsell');
				addToCartBtn.classList.add('variant-selected');
			}

			// Restablece el modal y el botón "Add to Bag" anteriores
			if (currentModal && currentModal !== contentVariants) {
				currentModal.classList.remove('show-variant-selected');
				currentAddToBagBtn.textContent = 'Add to Bag';
				resetVariantRadios(currentModal);
				currentAddToBagBtn.classList.remove('variant-selected');
				currentAddToBagBtn.classList.remove('add-to-cart-upsell');
			}

			currentModal = contentVariants; // Actualiza el modal actual
			currentAddToBagBtn = addToCartBtn; // Actualiza el botón "Add to Bag" actual


		});

		// Evento que se ejecuta cuando se selecciona una variante
		variantRadios.forEach(function (radio) {
			radio.addEventListener('change', function () {
				var selectedRadio = form.querySelector('input[name="id"]:checked');
				var price = selectedRadio.getAttribute('data-price');
				var variantId = selectedRadio.value; // Captura el ID de la variante seleccionada
				addToCartBtn.textContent = 'Add to Bag ' + price;
				addToCartBtn.setAttribute('data-variant-id', variantId); // Asigna el ID de la variante al botón
				addToCartBtn.classList.add('add-to-cart-upsell');
				contentVariants.classList.remove('no-variant-selected');
				addToCartBtn.classList.add('variant-selected');
			});
		});

		if (window.innerWidth < 768) {
			// Selecciona todos los elementos con la clase 'product__mobile--container'
			const containers = document.querySelectorAll('.product__mobile--container');
			// Selecciona todos los elementos con la clase 'product__mobile--id'
			const ids = document.querySelectorAll('.product__mobile--id');

			// Crea un conjunto de IDs para una búsqueda rápida
			const idsSet = new Set();
			ids.forEach(item => {
				idsSet.add(item.id);
			});

			// Itera sobre cada uno de los elementos seleccionados
			containers.forEach(container => {
				// Verifica si el ID del contenedor no está en el conjunto de IDs
				if (!idsSet.has(container.id)) {
					// Establece el z-index en 0 con !important
					container.style.setProperty('z-index', '0', 'important');
				}
			});
		}
	});
});

// Función para cerrar el modal
function closeModal(productId) {

	// debugger
	var contentVariants = document.querySelector('#content_variants_' + productId);
	if (contentVariants) {
		contentVariants.classList.remove('show-variant-selected');
	}
	document.body.classList.remove('body-variant-selected');

	// Restablece el z-index de los elementos con la clase "collection-z-index"
	if (document.querySelectorAll('.collection-z-index')) {
		const elements = document.querySelectorAll('.collection-z-index');
		elements.forEach(element => {
			element.addEventListener('click', () => {
				elements.forEach(el => el.style.setProperty('z-index', '2', 'important'));
				element.style.setProperty('z-index', '3', 'important');
			});
		});
	}

	// Selecciona todos los elementos con la clase 'hide-scrollbar'
	const elements__scroll = document.querySelectorAll('.hide-scrollbar');

	// Recorre cada elemento y elimina la clase 'overflow-auto' si está presente
	elements__scroll.forEach(element__scroll => {
		if (element__scroll.classList.contains('hide-scrollbar')) {
			element__scroll.classList.add('overflow-auto');

		}
	});

	document.querySelectorAll('.fixed-bottom').forEach(element => element.style.zIndex = 44);


	if (window.innerWidth <= 768) { // Puedes ajustar este valor según sea necesario para definir "móvil"
		// Encuentra el elemento con ambas clases
		var contentVariantsElements = document.querySelectorAll('.content_variants');
		// Itera sobre cada elemento
		contentVariantsElements.forEach(function (contentVariantsElement) {

			// Encuentra todos los elementos con la clase add-to-cart-btn dentro del elemento actual
			var addToCartButtons = contentVariantsElement.querySelectorAll('.add-to-cart-btn');
			// Itera sobre cada botón y cambia la propiedad bottom
			addToCartButtons.forEach(function (addToCartButton) {
				addToCartButton.style.setProperty('bottom', '-185px');
			});
		});
	}


	// Oculta los contenedores de variantes si la ventana es menor a 768px
	if (window.innerWidth < 768) {
		var variantContainers = document.querySelectorAll('.content_items--variant');
		variantContainers.forEach(function (variantContainer) {
			variantContainer.style.display = "none";
		});
	}

	// Variables para contenedores específicos en Safari
	if (document.querySelector('.safari__container')) {
		var containerModalSafari = document.querySelector('.safari__container');
	}
	if (document.querySelector('.safari__container--nowrap')) {
		document.querySelector('.safari__container--nowrap').classList.toggle('flex-nowrap');
	}

	// Oculta el contenido de fondo que coincide con el ID del producto
	document.querySelectorAll('.background__content').forEach(element => {
		if (element.id === productId) {
			element.classList.add('hidden');
		}
	});

	// Agrega la clase 'active' a '.background__nav'
	if (window.innerWidth < 768) {
		document.querySelector('.background__nav').classList.remove('active');
		document.querySelector('.background__nav').style.height = '0px'
	}


	if (containerModalSafari) {
		containerModalSafari.classList.add('overflow-auto');
	}


	if (contentVariants) {
		var addToCartBtn = contentVariants.querySelector('.add-to-cart-btn');

		var addToCartBtnOutside = contentVariants.querySelector('.add-to-cart-btn-outside');
		addToCartBtn.textContent = 'Add to Bag';
		addToCartBtn.classList.remove('variant-selected');
		addToCartBtn.classList.remove('add-to-cart-upsell');
		// Evento que se ejecuta cuando se hace clic en el botón "Add to Bag"
		addToCartBtn.addEventListener('click', function (event) {
			if (!contentVariants.classList.contains('show-variant-selected')) {
				event.preventDefault();
				contentVariants.classList.add('show-variant-selected');
			}
		});

		if (currentModal === contentVariants) {
			currentModal = null;
			currentAddToBagBtn = null;
		}
		resetVariantRadios(contentVariants); // Restablece los radios de variantes
	}

	document.querySelectorAll('.safari__container--nowrap').forEach(function (element) {
		element.classList.add('flex-nowrap');
	});
}








// Función para restablecer los radios de variantes
function resetVariantRadios(modal) {
	var variantRadios = modal.querySelectorAll('.variant-radio');
	variantRadios.forEach(function (radio) {
		radio.checked = false;
	});
}

/*========================= Show variants with Select stone (The Garden pendant)*/

document.addEventListener("DOMContentLoaded", function () {
	const productContainers = document.querySelectorAll('.content_variants'); // Selecciona todos los contenedores de variantes

	productContainers.forEach(function (container) {
		const stoneOptions = container.querySelectorAll('.stone-options li'); // Selecciona todas las opciones de piedra

		stoneOptions.forEach(function (option) {
			option.addEventListener('click', function () {
				const target = this.getAttribute('data-target');
				const targetName = this.getAttribute('data-name');

				stoneOptions.forEach(function (li) {
					li.classList.remove('active');
				});

				const forms = container.querySelectorAll('.stone-form');
				forms.forEach(function (form) {
					form.classList.remove('active');
				});

				this.classList.add('active');

				const formToShow = container.querySelector('#' + target);
				formToShow.classList.add('active');

				const variantStones = formToShow.querySelectorAll('.variant_stone');

				// Función para actualizar el precio
				function updatePrice() {
					const selectedRadio = formToShow.querySelector('.variant_stone:checked');
					const addToBagBtn = formToShow.querySelector('.btn_garden-pendant');
					if (selectedRadio) {
						const price = selectedRadio.getAttribute('data-price');
						const valueid = selectedRadio.getAttribute('value');
						addToBagBtn.textContent = 'Add to Bag ' + price;
						addToBagBtn.setAttribute('data-variant-id', valueid);
						addToBagBtn.classList.add('add-to-cart-upsell');
						addToBagBtn.classList.add('price-updated');
						addToBagBtn.classList.remove('price-added');
					} else {
						addToBagBtn.textContent = 'Add to Bag';
						addToBagBtn.classList.remove('price-updated');
						addToBagBtn.classList.remove('price-added');
						addToBagBtn.classList.remove('add-to-cart-upsell');
					}
				}

				variantStones.forEach(function (stone) {
					stone.addEventListener('change', updatePrice);
				});

				updatePrice();
			});

			if (option.classList.contains('active')) {
				option.click();
			}
		});


		// PLP hover behavior in desktop plp selectors
		stoneOptions.forEach(function (option) {
			option.addEventListener('click', function () {
				const target = this.getAttribute('data-target');
				const targetName = this.getAttribute('data-name');
				const dynamicImages = document.querySelectorAll('.dynamic-image');
				const dynamicImagesResponse = document.querySelectorAll('.dynamic-image__response');
				const click_redirects = this.closest('.card-hover'); // Selecciona la tarjeta específica

				if (window.matchMedia("(min-width: 768px)").matches) {
					dynamicImages.forEach(function (img) {
						if (img.id == targetName) {
							dynamicImagesResponse.forEach(function (imgRes) {
								const originalImage = img.src;
								const dynamicImage = imgRes.src;
								if (imgRes.id == target) {
									img.style.display = 'block';
									img.src = dynamicImage;
									img.nextElementSibling.style.display = 'none';

									// Definimos los manejadores de eventos dentro del contexto adecuado
									const handleMouseOver = function () {
										img.style.display = 'block';
										img.src = dynamicImage;
										img.nextElementSibling.style.display = 'none';
									};

									const handleMouseOut = function () {
										img.style.display = 'none';
										img.src = originalImage; // Cambia de vuelta a la imagen original
										img.nextElementSibling.style.display = 'block';
									};

									// Eliminamos event listeners anteriores específicos para esta imagen
									click_redirects.removeEventListener('mouseover', handleMouseOver);
									click_redirects.removeEventListener('mouseout', handleMouseOut);

									// Asignamos los nuevos event listeners
									click_redirects.addEventListener('mouseover', handleMouseOver);
									click_redirects.addEventListener('mouseout', handleMouseOut);
								}
							});
						}
					});
				}
			});
		});


		// Evento que se ejecuta cuando se hace clic en el botón "Add to Bag"
		container.querySelectorAll('.btn_garden-pendant').forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				const priceUpdated = this.classList.contains('price-updated');



				// Selecciona todos los elementos con la clase 'hide-scrollbar'
				const elements__scroll = document.querySelectorAll('.hide-scrollbar');

				// Recorre cada elemento y elimina la clase 'overflow-auto' si está presente
				elements__scroll.forEach(element => {
					if (element.classList.contains('overflow-auto')) {
						element.classList.remove('overflow-auto');
					}
				});


				if (!priceUpdated) {
					event.preventDefault();
					const contentStone = this.closest('.content_stone');
					contentStone.classList.add('bag-opened');

					document.querySelectorAll('.fixed-bottom').forEach(element => element.style.zIndex = 4);

					if (document.querySelector('.safari__container')) {
						var containerModalSafari = document.querySelector('.safari__container');

						if (containerModalSafari) {
							containerModalSafari.classList.remove('overflow-auto');
							containerModalSafari.style.overflow = '-webkit-paged-y';
						}
					}

					if (document.querySelector('.z-0')) {
						document.querySelector('.z-0').classList.add('changed');
						document.querySelector('.background__content').classList.remove('hidden');
					}

					const elements__pdp = document.querySelectorAll('.products-pdp .select_stone-items .content_stone .btn_garden-pendant');

					// Aplica el estilo z-index 0 a cada elemento seleccionado
					elements__pdp.forEach(function (element) {
						element.style.setProperty('bottom', '0', 'important');
						document.querySelector('.background__content').classList.remove('hidden');
					});

					if (window.innerWidth < 768) {
						var heightNavigationCarrousel = document.querySelector('.naviagtion__carousel').offsetHeight
						var heightNavigationNavigation = document.querySelector('.navigation__home').offsetHeight
						var heightNavigationAll = heightNavigationCarrousel + heightNavigationNavigation
						document.querySelector('.background__nav').classList.add('active');
						document.querySelector('.background__nav').style.height = heightNavigationAll + 'px'
					}
					if (window.innerWidth > 768) {
						document.querySelector('nav').style.zIndex = '9';
					} else {
						document.querySelector('nav').style.zIndex = '10';
					}
					document.body.classList.add('body-stone-selected');

				}
			});
		});

		// Evento que se ejecuta cuando se hace clic en el botón "close_stone"
		container.querySelectorAll('.close_stone').forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				event.preventDefault();




				const contentStone = this.closest('.content_stone');
				contentStone.classList.remove('bag-opened');
				if (document.querySelector('.z-0')) {
					document.querySelector('.z-0').classList.remove('changed');
				}



				// Seleccionar todos los elementos con la clase 'safari__container'
				const safariContainersClose = document.querySelectorAll('.safari__container');

				// Iterar sobre cada uno de los elementos seleccionados
				safariContainersClose.forEach(container => {
					// Agregar la clase 'overflow-auto'
					container.classList.add('overflow-auto');
				});
				const elements = document.querySelectorAll('.products-pdp .select_stone-items .content_stone .btn_garden-pendant');

				// Aplica el estilo z-index 0 a cada elemento seleccionado
				elements.forEach(function (element) {
					element.style.setProperty('bottom', '-185px', 'important');
					document.querySelector('.background__content').classList.remove('hidden');
				});


				document.querySelector('.background__content').classList.add('hidden');
				document.body.classList.remove('body-stone-selected');

				if (window.innerWidth < 768) {
					document.querySelector('.background__nav').classList.remove('active');
					document.querySelector('.background__nav').style.height = '0px'
				}
				const activeForm = container.querySelector('.stone-form.active');

				if (activeForm) {
					const addToBagBtn = activeForm.querySelector('.btn_garden-pendant');
					addToBagBtn.classList.remove('price-updated');
					addToBagBtn.classList.remove('add-to-cart-upsell');
					addToBagBtn.textContent = 'Add to Bag';
					event.preventDefault();
				}



				// Selecciona todos los elementos con la clase 'hide-scrollbar'
				const elements__scroll = document.querySelectorAll('.hide-scrollbar');



				// Recorre cada elemento y elimina la clase 'overflow-auto' si está presente
				elements__scroll.forEach(element__scroll => {


					if (element__scroll.classList.contains('hide-scrollbar')) {
						element__scroll.classList.add('overflow-auto');

					}
				});

				document.querySelectorAll('.fixed-bottom').forEach(element => element.style.zIndex = 44);
			});
		});
	});
});


document.addEventListener("DOMContentLoaded", function() {
    // Obtener la URL actual
    var currentUrl = window.location.href;

    // Especifica el valor que deseas buscar en la URL
    var urlKeyword = "pages";

    // Obtener el div por su ID
    var miDiv = document.getElementById("products-with-title__slider");

    // Verificar si la URL contiene la palabra clave especificada
    if (currentUrl.includes(urlKeyword)) {

        // Agregar la clase al div si se encuentra la palabra clave en la URL
        miDiv.classList.add("products-pdp");

    }
});
